module.exports = __webpack_public_path__ + "img/file.7132a512.svg";